import React from "react";
import { Container } from "reactstrap";

// import Hero from "../blocks/Hero/Hero";
import ResourcesCards from "../components/Resources/ResourcesCards";

const taxonomy = window._edo_taxonomy;
// console.log({taxonomy});

export const TaxonomyExperienceTag = () => {
  const type = taxonomy.type === 'locations' ? 'state' : taxonomy.type === 'concerns' ? 'concern' : taxonomy.type;
  const filter = taxonomy && type === 'outcomes' ? [taxonomy.slug] : taxonomy?.slug;
  
  return (
    <Container>
      {/* <Hero
        background={{ url: taxonomy?.featured_image }}
        text={taxonomy?.description || taxonomy?.name}
        cta=""
      /> */}
      <ResourcesCards filter={{ [type]: filter }} collectionView />
    </Container>
  );
}

export default TaxonomyExperienceTag;
